import { GetOneContentOutDto, GetOneContentInDto } from '../../../types/content.dto'

export const GET_ONE_CUSTOM_CONTENT_TYPE = 'GET_ONE_CUSTOM_CONTENT_TYPE'
export const GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS = 'GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS'
export const GET_ONE_CUSTOM_CONTENT_TYPE_ERROR = 'GET_ONE_CUSTOM_CONTENT_TYPE_ERROR'
export const RESET_GET_ONE_CUSTOM_CONTENT_TYPE = 'RESET_GET_ONE_CUSTOM_CONTENT_TYPE'

export interface GetOneCustomContentType {
  type: typeof GET_ONE_CUSTOM_CONTENT_TYPE
  payload: GetOneContentOutDto
}

export interface GetOneCustomContentTypeSuccess {
  type: typeof GET_ONE_CUSTOM_CONTENT_TYPE_SUCCESS
  payload: GetOneContentInDto
}

export interface GetOneCustomContentTypeError {
  type: typeof GET_ONE_CUSTOM_CONTENT_TYPE_ERROR
  payload: string | boolean
}

export interface ResetGetOneCustomContentType {
  type: typeof RESET_GET_ONE_CUSTOM_CONTENT_TYPE
  payload: null
}

export interface State {
  data: GetOneContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetOneCustomContentType
  | GetOneCustomContentTypeSuccess
  | GetOneCustomContentTypeError
  | ResetGetOneCustomContentType
